export default __webpack_public_path__ + "static/media/icon_detalles_selected.c73a052a.svg";